const run_vars = window.APP_CONFIG || {};

export const hostServer = run_vars.API_URL || "https://api.updamus.com";
